import { render } from "./suoluomenTable.vue?vue&type=template&id=00cadc24&scoped=true"
import script from "./suoluomenTable.vue?vue&type=script&lang=js"
export * from "./suoluomenTable.vue?vue&type=script&lang=js"

import "./suoluomenTable.vue?vue&type=style&index=0&id=00cadc24&lang=less&scoped=true"

import exportComponent from "/Users/apple/Desktop/wb/meta-psy-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cadc24"]])

export default __exports__